import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'es',
        debug: false,
        supportedLngs: ['es', 'en'],
        defaultNS: 'translation',

        interpolation: {
            escapeValue: false, // React ya se encarga de escapar valores
        },

        // Configuración para detectar el idioma del navegador si no hay cookie/localStorage
        detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage', 'cookie'],
        },

        backend: {
            // Ruta donde i18next buscará los archivos de traducción
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        }
    });

export default i18n;
